import * as React from 'react';
import * as moment from 'moment';

import { ICalendarState, IMonth, IDay } from '../../classes/calendar';
import { connect } from 'react-redux';

import GridMonthsView from 'grid-months.view';
import { ICalendarAppState } from '../../redux-state';
import { ICalendarAppText } from '../../custom/classes/calendar-text';
import { IEvent } from '../../custom/classes/event';

interface IGridMonthsExternalProps {
}

interface StateToProps {
    monthsData: IMonth<IEvent>[];
    text: ICalendarAppText;
    currentMoment: moment.Moment;
    updating: boolean;
}

export type GridMonthsProps = IGridMonthsExternalProps & StateToProps;

export class GridMonthsBase extends React.Component<GridMonthsProps, any> {
    render() {
        return (
            <GridMonthsView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IGridMonthsExternalProps): StateToProps {
    return {
        monthsData: state.calendar.events,
        text: state.calendarText,
        currentMoment: state.calendar.currentDate,
        updating: state.calendar.updating
    }
}

export default connect<StateToProps>(mapStateToProps)(GridMonthsBase);